// Wpłata przelewem bankowym oczekująca na rozliczenie (RPC `admin_list_bank_transfer_purchases`,
// wzbogacona przez backend o oczekiwaną kwotę z ceny Stripe).

export type PurchaseSettlementStatus = "pending" | "settled" | "all";

export interface BankTransferPurchase {
  id: string;
  pretty_id: string | null;
  participant_id: string;
  participant_name: string | null;
  user_email: string | null;
  created_at: string;
  stripe_price_id: string | null;
  type_id: number | null;
  plan_name: string | null;
  plan_interval: "year" | "month" | "week" | "day" | null;
  /** Deklaracja usera („Potwierdzam płatność przelewem") — NIE dowód wpływu pieniędzy. */
  confirmed: boolean;
  /** Kiedy admin oznaczył wpłatę jako otrzymaną. NULL = do rozliczenia. */
  settled_at: string | null;
  settled_by_email: string | null;
  settled_subscription_id: string | null;
  /** Best-effort z ceny Stripe: oczekiwana kwota w groszach + waluta (mogą być nieobecne). */
  amount_minor?: number;
  currency?: string;
}

export interface BankTransferPurchasesResponse {
  data: BankTransferPurchase[];
}

/** Wynik RPC `settle_bank_transfer_purchase` przekazany przez backend. */
export interface SettlePurchaseResult {
  already_settled: boolean;
  purchase_id: string;
  participant_id?: string;
  subscription_id: string | null;
  created_subscription?: boolean;
  type_id?: number;
  interval?: string;
  start_date?: string;
  end_date?: string;
  settled_at?: string;
  settled_by_email?: string;
}

export interface SettlePurchaseResponse {
  success: boolean;
  data: SettlePurchaseResult;
}

const INTERVAL_LABELS: Record<NonNullable<BankTransferPurchase["plan_interval"]>, string> = {
  year: "rok",
  month: "miesiąc",
  week: "tydzień",
  day: "dzień",
};

export function intervalLabel(interval: BankTransferPurchase["plan_interval"]): string {
  return interval ? INTERVAL_LABELS[interval] : "";
}

export function formatAmount(purchase: BankTransferPurchase): string {
  if (purchase.amount_minor == null) return "—";
  const currency = (purchase.currency || "PLN").toUpperCase();
  try {
    return (purchase.amount_minor / 100).toLocaleString("pl-PL", {
      style: "currency",
      currency,
    });
  } catch {
    return `${(purchase.amount_minor / 100).toFixed(2)} ${currency}`;
  }
}
